<script>
  import {
    VDialog
  } from 'vuetify/lib'
  export default {
    name: 'wh-dialog',
    extends: VDialog
  };
</script>